import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueMeta from "vue-meta";

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
  // optional sauberere Attribute:
  attribute: "data-vue-meta",
  tagIDKeyName: "vmid",
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
